export const ERROR_CODE = {
  SHOP_CLOSE: 201003401, // 店铺打烊
  BAN_PROMOTION: 2000003, // 风控 优惠剥夺
  SHOP_OFFLINE: 201003201, // 门店下架
  SHOP_PRODUCT_OFF: 2000011, // 加购商品下架
  CART_MAX_COUNT: 201003701, // 超过购物车最大加购数量
  PICKUP_OFFLINE: 201003223, // 门店自提下线
};

export const SALES_TYPE = {
  CALORIE: -1, //卡路里，前端合并到一起展示
  POINT: -2, //卡路里后边那个小点
  SALES: 0, // 销量类型
  OTHER: 1 // 其它类型，菜品回购类型，菜品排名类型等等
};

export const SCENE_TYPE = {
  PULL: 2, // 拉取全局购物车数据数据
  UPDATA: 3 // 修改购物车数据
};

/** shopinfo接口返回门店状态 */
export const SHOP_STATUS = {
  /** 录入中 */
  SHOP_ENTERING: 1,
  /** 待营业 */
  SHOP_OPEN_SOON: 2,
  /** 营业中 */
  SHOP_OPEN: 3,
  /** 打烊 */
  SHOP_CLOSE: 4,
  /** 已下线 */
  SHOP_OFFLINE: 5,
};

/** 价格计算接口返回门店状态 */
export const SHOP_AVAILABLE = {
  /** 营业中 */
  SHOP_OPEN: 1,
  /** 非营业状态（不可用） */
  SHOP_CLOSE: 0
};

export const MULTI_SKU_ERROR_CODE = {
  ...ERROR_CODE,
  SHOP_REST: 201003202, //店铺打烊
  NO_INVENTORY: 201003203, //无库存
  UNAVAILABLE: 201003212, //未在可售时间
  STYSTEMERROR: 1, //系统异常
  NINE_ONE_NINE_INVALIDATE: 2000018, // 用户不在享受919活动
  NINE_ONE_NINE_OUT_OFF_STOCK: 2000019, // 919活动商品库存不足
  NINE_ONE_NINE_OFFLINE: 2000020, // 919活动已下线
  UN_SELECTED_REQUIRED_PRODUCT: 2000012, // 未选择必选菜
};

// 门店页商家列表 快速加购按钮折叠状态
export const ADD_BTN_FOLD_STATUS = {
  EXPAND_START: 1, // 开始展开
  EXPAND_END: 2, // 展开完成
  FOLD_START: 3, // 开始折叠
  FOLD_END: 4, // 折叠完成
};

// 价格接口请求状态
export const CALCULATE_PRICE_STATUS = {
  LOADING: 0, // 请求中
  SUCCESS: 1, // 返回成功
  ERROR: 2, // 返回失败
};

// 门店活动类型
export const SHOP_ACTIVITY_TYPE = {
  /** 折扣菜 */
  DISCOUNT_FOOD: 18,
  /** 满折 */
  FULL_DISCOUNT: 3,
  /** 满减 */
  FULL_REDUCE: 2,
};

/** 修改购物车商品的来源 */
export const CHANGE_CART_SOURCE = {
  /** 多规格浮层 */
  MULTI_MODAL: 1,
  /** 门店列表商品卡片 */
  FOOD_LIST: 2,
  /** 购物车浮层 */
  CART_LIST: 3,
  /** 凑单列表浮层 */
  ADD_ITEM_LIST: 4,
};

/** 购物车浮层商品卡片按钮类型 */
export enum ButtonType {
  /** 加 */
  ADD = 0,
  /** 减 */
  DES = 1
}
/** 公共弹窗按钮类型 */
export enum CommonDialogButtonType {
  /** 取消 */
  CANCEL = 0,
  /** 确认 */
  CONFIRM = 1,
}

/** 埋点参数值为空时传入-999 */
export const STATISTICS_NON_VALUE = '-999';
/** 门店商品卡片按钮类型（埋点使用） */
export const PRODUCT_CARD_BTN_TYPE = {
  /** 单规格商品加号 */
  SINGLE_ADD: 1,
  /** 单规格商品减号 */
  SINGLE_DES: 2,
  /** 多规格商品加号 */
  MUTIL_ADD: 3,
};

/** 进入门店预览渠道来源 */
export enum ShopChannel {
  /** 特殊渠道，bd全供给渠道 */
  BD = 'bd',
  /** 特殊渠道，开放平台渠道 */
  OPEN = 'open',
  /** 特殊渠道，商家渠道 */
  MERCHANT = 'merchant',
  /** 特殊渠道，商家管理渠道 */
  PARTNER = 'partner'
}

/** 门店购物车活动条动画状态： start:开始 end:结束 */
export const CART_ACT_ANIM_TYPE = {
  START: 'start',
  END: 'end'
};

/** 是否满足满折门槛 */
export const IS_MEET_SILL_AMOUNT = {
  /** 不满足 */
  0: 0,
  /** 满足 */
  1: 1
};

/** preview提单拦截弹窗类型 */
export const ALERT_INFO_TYPE = {
  /** 普通类型 */
  NORMAL: 0,
};

// 0默认，单列, 1 双列, -100 兜底卡片（1pt高度）
export const SHOP_CATEGORY_TYPE_SINGLE_COLUMN = 0;
export const SHOP_CATEGORY_TYPE_DOUBLE_COLUMN = 1;
export const SHOP_CATEGORY_TYPE_DEFAULT = -100;
export const SHOP_SPU_ID = -1;
// 推荐菜
export const SPU_TYPE_RECOMMAND = 1;
// 折扣菜
export const SPU_TYPE_DISCOUNT = 2;
// 融合菜（是折扣菜也是推荐菜)
export const SPU_TYPE_RECOMMAND_RECOMMAND = 3;

// 用户获取餐品方式
export enum UserGetMode {
  delivery = 'delivery',
  pickup = 'pickup',
}
// init：页面初始化 login: 登录后请求 switchTab 切换模式tab请求
export enum REQUEST_SCENE {
  init = 'init',
  login = 'login',
  switchTab = 'switchTab',
}

/** 购物车算价场景 */
export enum CALCULATE_PRICE_REQUEST_SCENE {
  switchTab = 'switchTab',
  addCart = 'addCart'
}

export const QRCODE_SCENE = {
  shopPickup: '1', // 自提门店扫码进入
};

/** 分页列表锚点加载状态 */
export enum AnchorFoodListStatus {
  loading,
  success,
  error
}

/** 触发分类列表加载更多类型的场景 */
export enum LoadMoreBottomType {
  /** 锚点切菜品分类Tab */
  anchor,
  /** 上拉加载更多 */
  normal
}
/** 打开多规格浮层（进入门店页scheme带openMultiSku参数） */
export const OPEN_MULTI_SKU = {
  OPEN: '1',
  CLOSE: '0'
};
/**
 * 门店周年庆标签类型
 * 1：门店标签
 * 2：营销标签
 */
export const SHOP_CELEBRATE_TYPE = {
  SHOP_LABEL: 1,
  PROMOTION_LABEL: 2
};

/**
 * 门店周年庆标签样式类型
 * 0：普通图片
 * 1：动态标签
 */
export const SHOP_FEATURE_STYLE = {
  NORMAL_PIC: 0,
  DYNAMIC_TAG: 1
};
